import { render, staticRenderFns } from "./MemberHistory.vue?vue&type=template&id=95e2aef6&scoped=true&"
import script from "./MemberHistory.vue?vue&type=script&lang=js&"
export * from "./MemberHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e2aef6",
  null
  
)

export default component.exports